<template>
  <CRow>
    <CCol sm="12">

      <CCard>

        <CCardHeader>
          <CIcon name="cil-calendar"/>
          Bestehende allgemeine Freizeit / Fortbildung ändern
        </CCardHeader>

        <CCardBody>
          <ValidationObserver v-slot="{ invalid }">
            <CForm class="no-mb" @submit.prevent="updateFreizeit()">

              <FreizeitText v-model="name" formLabel="Name"/>
              <FreizeitDatum v-model="datum" formLabel="Datum der Freizeit / Fortbildung"/>
              <FreizeitNumber v-model="dauer" formLabel="Dauer der Freizeit / Fortbildung"/>

              <FormError v-if="formError" :errormessage="formError"/>

              <CRow class="mt-4">
                <CCol col="12" class="text-right">
                  <CButton color="primary" class="px-4" :disabled="invalid" type="submit">Freizeit / Fortbildung ändern</CButton>
                </CCol>
              </CRow>

            </CForm>
          </ValidationObserver>
        </CCardBody>

      </CCard>

    </CCol>
  </CRow>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import FormError from '@/components/FormError'
import FreizeitText from '@/components/FormElements/Text'
import FreizeitNumber from '@/components/FormElements/Number'
import FreizeitDatum from '@/components/FormElements/Date'

export default {
  name: 'MitarbeiterEdit',
  components: {
    FormError,
    FreizeitText,
    FreizeitNumber,
    FreizeitDatum
  },
  props: {
    uuid: [Number, String]
  },
  data () {
    return {
      name: '',
      datum: '',
      dauer: 8.00,
      formError: null
    }
  },
  mounted () {
    if (this.uuid) {
      Vue.axios.get('/freizeit/get/' + this.uuid)
        .then((response) => {
          this.name = response.data.name
          this.datum = this.dateFormatter(response.data.datum)
          this.dauer = this.floatFormatter(response.data.dauer)
        })
    }
  },
  methods: {
    floatFormatter (value) {
      if (typeof value === 'string') {
        return parseFloat(value)
      } else {
        return value
      }
    },
    dateFormatter (value) {
      if (value) {
        value = moment(value).format('DD.MM.YYYY')
      } else {
        value = null
      }
      return value
    },
    updateFreizeit () {
      Vue.axios.put('/freizeit/put/' + this.uuid, {
        name: this.name,
        datum: this.datum,
        dauer: this.dauer
      }).then((response) => {
        this.$router.push({ path: '/freizeit/uebersicht' })
        this.$snotify.success('Die Freizeit / Fortbildung wurde angepasst.', {
          position: 'rightTop',
          timeout: 4000
        })
      }).catch((error) => {
        this.formError = error.response.data
      })
    }
  }
}
</script>
